import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-social.module.scss"
import Grid from "../../atoms/grid"
import Heading from "../../atoms/heading"

const NewsletterSocial = ({ section, styling }) => (
  <div className={styling === "lifestyle" ? styles.grid__lifestyle : ""}>
    {section.title ? (
      <div className={styling === "lifestyle" ? styles.title__lifestyle : ""}>
        {section.icon ? (
          <div className={styles.icon}>
            <Image {...section.icon?.image} width={60} height={60} alt="" />
          </div>
        ) : (
          ""
        )}
        <div className={styles.titleInner}>
          {section.subtitle ? (
            <Heading level={6}>{section.subtitle}</Heading>
          ) : (
            ""
          )}
          {styling === "lifestyle" ? (
            <div className={styles.titleText}>{section.title}</div>
          ) : (
            <Heading level={4}>{section.title}</Heading>
          )}
        </div>
        {section.icon ? (
          <div className={styles.icon}>
            <Image {...section.icon?.image} width={60} height={60} alt="" />
          </div>
        ) : (
          ""
        )}
      </div>
    ) : (
      ""
    )}
    <Grid nowrap tight col={section.posts.length}>
      {section.posts.map((post) => (
        <div className={styling === "lifestyle" ? styles.post__lifestyle : ""}>
          {post.title ? <Heading level={4}>{post.title}</Heading> : ""}
          <a href={post.url} target="_blank" rel="noreferrer">
            <Image
              className={`${styles.image} ${styling === "lifestyle" ? styles.image__lifestyle : ""}`}
              {...post.image}
              width={400}
              alt={post.caption}
            />
          </a>
          <div
            className={`${styles.caption}
            ${styling === "lifestyle" ? styles.caption__lifestyle : ""}`}
          >
            {post.caption}
          </div>
        </div>
      ))}
    </Grid>
  </div>
)

export default NewsletterSocial

NewsletterSocial.propTypes = {
  section: PropTypes.object.isRequired,
  styling: PropTypes.string,
}

NewsletterSocial.defaultProps = {
  styling: "",
}
